import React, { HTMLAttributes } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";

import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Business: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  // const {isLogin} = store.user;
  
  const businessHtml = () => {
    return (
      <div dangerouslySetInnerHTML={{__html: t('aboutus.business')}} />
    )
  }

  return (
    <div className={cx(`${styles.global}`, className)} style={{ backgroundImage: `url(${require("@/assets/images/aboutus/banner2.png")})`}}>
      <div className={cx(`${styles.titleAll}`, className)}>
        {businessHtml()}
      </div>
      <div className={cx(`${styles.desBOX}`, className)}>
        <div>{t("aboutus.platformIntroduce4") }</div>
        <div>{t("aboutus.platformIntroduce5") }</div>
      </div>
    </div>
  );
};

export default Business;
